// extracted by mini-css-extract-plugin
module.exports = {"Tag":"Tag_Tag__MEuQu","isGray":"Tag_isGray__DYThc"};